import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TokenService } from 'src/app/shared/services/token.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Router } from '@angular/router';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { GetterSetterService } from 'src/app/shared/services/getter-setter.service';
import { BaseResponse } from 'src/app/models/response';

import { BusinessEntityService } from 'src/app/shared/services/business-entity.service';
import { productAccessName } from '../../../shared/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-business-header',
  templateUrl: './business-header.component.html',
  styleUrls: ['./business-header.component.scss']
})
export class BusinessHeaderComponent implements OnInit {

  @ViewChild('inviteDTUser') inviteDTUserTemplate!: TemplateRef<any>; // template ref

  BNBusinessList: any = [];
  subArrowShow: boolean;
  BNSelectedComs: any;
  NavEntityContext: any;
  isRole: any;
  companyId: any;
  BNModel: any;
  businessName: any;
  familyData: any;
  business_role: any;
  count: number;
  gstin_count: number;
  companyList: any;
  gstnMsg: boolean;
  currentUser: String;
  selectedcom: any;
  userRole: any;
  rootBusinessName: string;
  productAccessName: { onyx: string; topaz: string; sapphire: string; };
  currentProductAccess: string;
  isExpressTDSAccess: boolean;
  dtUserRole: string;
  dtInviteUsers: any[] = [];
  selectedDTUser: any = null;


  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private router: Router,
    private toaster: ToasterService,
    private entityService: BusinessEntityService,
    private GetSet: GetterSetterService,
    private getterSetter: GetterSetterService,
    private modalService: NgbModal,
    private http: HttpClient

  ) {
    this.productAccessName = productAccessName;
  }

  ngOnInit() {
    this.initializeData();
  }

  initializeData() {
    this.currentUser = localStorage.getItem('user');
    this.rootBusinessName = localStorage.getItem('company');
    const authToken = localStorage.getItem('logintoken') ? localStorage.getItem('logintoken') : null;
    if (authToken) {
      this.getBusinessHierarchy();
    }
    this.currentProductAccess = localStorage.getItem('products');
    let tempArrProduct = this.currentProductAccess.split(',');
    if(tempArrProduct && tempArrProduct.includes('DT')) {
      this.isExpressTDSAccess = true;
    } else {
      this.isExpressTDSAccess = false;
    }
    this.dtUserRole = localStorage.getItem('DT_USER_ROLE');
    // this.changeBusiness(localStorage.getItem('companyId'));
  }
  navigateDashboard() {
    this.router.navigate([`dashboard`]);
  }

  logout() {
    if (this.tokenService.destroy()) {
      this.authService.setLoginIndicator(0);
      this.router.navigate(['login']);
    } else {
      this.toaster.showError('Something Went wrong !');
    }
  }
  logout_Sovos() {
      const url = environment.apiUrl + '/sovos/auth/logout';    
       try {
      this.http.get(url).subscribe(() => { }, () => { });
    } catch (e) {
    }

  }
  goToAddBusissness() {
    this.router.navigate([`add-business`]);
  }
  goToChangePassword(type) {
    if (type == 'changePass')
      this.router.navigate([`update-profile`]);
  }

  getBusinessHierarchy() {
    setTimeout(() => {
      let cmpId = localStorage.getItem('companyId') ? localStorage.getItem('companyId') : null;
      if (cmpId) {
        this.entityService.fetchEntity().subscribe((response: BaseResponse) => {
          this.BNBusinessList = response.response;
          this.BNBusinessList.sort((a,b) => a.company.localeCompare(b.company));
          if (cmpId) {
            this.entityService.fetchBusinessHierarchy(cmpId).subscribe((response: BaseResponse) => {
              this.BNModel = response.response;
              this.isRole = response.response.roleName;

            }, (err) => {
              // this.toaster.showError("Network Error");
            });
          }
        }, (err) => {
          // this.toaster.showError("Network Error");
        });
      }
    }, 1000)
  }

  getSetNavContext(navContext?) {
    if (navContext) {
      localStorage.setItem('navContext', JSON.stringify(navContext));
      this.getterSetter.setBusinessData(navContext);
    } else {
      navContext = JSON.parse(localStorage.getItem('navContext'));
      if (!navContext) {
        navContext = { entityName: '', isTaxPayer: false }
      }
    }
    return navContext;
  }

  changeBusiness(companyId) {
    if (companyId) {
      this.entityService.changeCompany(companyId).subscribe((response: BaseResponse) => {
        this.BNSelectedComs = [];
        if (response.status === 'SUCCESS') {
          if (response.response && response.response.length > 0 && response.response[0].companyid) {
            let companyId = response.response[0].companyid;
            let company = response.response[0].company;
            if(response.response[0].hasTenantChanged) {
              this.logout();
            }
            if(response.response[0].sapphireTenant) {
              this.GetSet.getSetSapphireTenent(response.response[0].sapphireTenant);
            }
            this.NavEntityContext = { entityName: '', isTaxPayer: false, entityType: 'Business' };
            this.getSetNavContext(this.NavEntityContext);
            this.subArrowShow = true;
            this.GetSet.getSetCompanyId(companyId);
            this.GetSet.getSetCompany(company);
            this.getBusinessHierarchy();
            if (response.response[0].products.length > 0) {
              this.GetSet.setProduct(response.response[0].products);
              if(response.response[0].products.includes('DT')) {
                this.isExpressTDSAccess = true;
              } else {
                this.isExpressTDSAccess = false;
              }
            }
            /**
             * Code for reloading route after action
             */
            this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
            this.router.navigateByUrl('dashboard')
              .then(() => {
                this.router.navigated = false;
                this.router.navigate([`dashboard`]);
              });
            /**
             * end
             */

            this.toaster.showSuccess(response.message);
          }
        } else {
          this.toaster.showInfo(response)
        }
      }, (err) => {
        // this.toaster.showError("Network Error!");
      });
    }
  }

  GotoUserDash() {
    this.NavEntityContext = { entityName: '', isTaxPayer: false, entityType: 'Business' };
    this.getSetNavContext(this.NavEntityContext);
    this.BNModel = {};
    this.subArrowShow = true;
    this.BNSelectedComs = [];
    this.getBusinessHierarchy();
  }

  inviteUserClick() {
    this.authService.fetchDTUsers(this.GetSet.getSetCompanyId()).subscribe((resp: any) => {
      if(resp && resp.status === 'SUCCESS') {
        if(resp.response && resp.response.length > 0) {
          this.dtInviteUsers = resp.response;
          this.modalService.open(this.inviteDTUserTemplate, { ariaLabelledBy: 'modal-basic-title' });
        } else {
          this.toaster.showWarning('No users found to invite');
        }
      }
    })

  }

  inviteUser() {
    if(this.selectedDTUser) {
      this.authService.inviteDTSubUser({ email: this.selectedDTUser.email }).subscribe(
        (resp: any) => {
          if(resp.status === 'SUCCESS') {
            this.toaster.showSuccess(resp.message);
            this.modalService.dismissAll();
          }
        },
        (e) => {
           if(e.error.errorList && e.error.errorList.length > 0) {
            e.error.errorList.forEach(e => {
              if(e.type === 'ERROR') {
                this.toaster.showError(e.description);
              }
            })
          } else if(e.error.status === 'FAILURE') {
            this.toaster.showError(e.error.message);
          }

        }
      )
    }
  }

  selectUserChange() {
    console.log(this.selectedDTUser)
  }
}
